import { Box, Typography } from "@mui/material";
import { StyledContact } from "./Contact.styled";
import { Map } from "../../Components/googleMap/GoogleMap";
import { ContactForm } from "../../Components/contactForm/ContactForm";
import { Message } from "../../Models/Message";
import { useMessage } from "../../stores/useMessage";

export const ContactPage = () => {
  const { addMessage } = useMessage();

  const sendMessage = async (message: Message) => {
    const newMessage: Message = {
      ...message,
      message: message.message.replaceAll("\n", "[/breakline]"),
    };

    const status = await addMessage(newMessage);
  };

  return (
    <StyledContact>
      <Box className="header">
        <Typography variant="h1">Contact</Typography>
      </Box>
      <Box className="infoWrapper">
        <Box className="content">
          <Typography variant="h2">Atelier Bijnens A.rt</Typography>
          <Typography variant="h4">
            Basilieklaan 10 3270 Scherpenheuvel
          </Typography>
          <Typography variant="h4">
            Open op <strong>zaterdag en zondag van 13u-17u</strong>. De Galerij
            kan in uitzonderlijke gevallen gesloten zijn. Wil je toch niet voor
            een gesloten deur staan, maak dan op voorhand een afspraak. Tel nr{" "}
            <strong>0494/99 39 71</strong>.
          </Typography>
          <Typography variant="h4">
            Van dinsdag tot en met vrijdag open op afspraak
          </Typography>

          <Box className="mapWrapper">
            <Box className="map">
              <Map />
            </Box>
          </Box>
        </Box>
        <Box className="formWrapper">
          <ContactForm onSend={(message) => {sendMessage(message)}} />
        </Box>
      </Box>
    </StyledContact>
  );
};
